import { HandleChangeProps } from "DataTypes/Common";
import { DropdownArrPropsType, FormDataType } from "DataTypes/Form";
import FormValidation from "./Validation";
import { useSearchParams } from "react-router-dom";

export const HandleFormChange: (
  data: HandleChangeProps,
  formArr: FormDataType[]
) => FormDataType[] = ({ value, id }, formArr) => {
  return formArr.map((formEl) => {
    if (formEl.id == id) {
      formEl.value = formEl.dropValue = value;
      const temp = FormValidation(formEl);
      formEl.error = temp.error;
      formEl.errorText = temp.errorText;
    }
    return formEl;
  });
};
export const CheckStringEmpty: (data: any) => string = (data) => {
  const string1 = typeof data == "string" ? data : "";
  const string2 = string1.trim();
  const string3 = string2.replaceAll(/&nbsp;/g, " ");
  return string3;
};

export const CheckNumber: (data: any) => number | null = (data) => {
  return typeof data == "number" ? data : null;
};

export const CheckArr: (data: any) => any[] = (data) => {
  return Array.isArray(data) ? data : [];
};

export const ValidateFormData: (formData: FormDataType[]) => {
  formData: FormDataType[];
  errorCheck: boolean;
} = (formData) => {
  let singleEntryErrorCheck = false;
  const newArr = formData.map((el) => {
    let result = { error: false, errorText: "" };
    if (el.required || el.value) result = FormValidation(el);
    if (result.error) singleEntryErrorCheck = true;
    el.errorText = result.errorText;
    el.error = result.error;
    return el;
  });
  return { formData: newArr, errorCheck: singleEntryErrorCheck };
};

export const FormatDropdownData: (
  data: any,
  idKey: string,
  labelKey: string,
  valKey: string
) => DropdownArrPropsType[] = (data, idKey, labelKey, valKey) => {
  return data?.map((el: any, index: number) => ({
    id: idKey ? el[idKey] : index,
    label: el[labelKey],
    value: el[valKey],
  }));
};

export const filterByAnyValue = (array: any, input: string) => {
  if (!input) return array;

  const lowerInput = input.toLowerCase();

  return array.filter((item: any) =>
    Object.values(item).some(
      (val) =>
        val !== null &&
        val !== undefined &&
        val.toString().toLowerCase().includes(lowerInput)
    )
  );
};

export const Admin_Number = 9876541230;

export const useSavedData = () => {
  const [searchParams] = useSearchParams();

  const getSavedData = () => {
    try {
      const saved = localStorage.getItem("userPurchaseData");
      if (saved) {
        return JSON.parse(saved);
      }

      const dataParam = searchParams.get("data")
      if (dataParam) {
        const decoded = JSON.parse(decodeURIComponent(dataParam));

        localStorage.setItem("userPurchaseData", JSON.stringify(decoded));
        return decoded;
      }
    } catch (err) {
      console.error("❌ Error reading saved data:", err);
    }

    return null;
  };

  return getSavedData;
};
